import { useEffect, useState } from 'react'

export const mediumDateOnlyFormatter = new Intl.DateTimeFormat('en-US', {
  dateStyle: 'medium',
  timeZone: 'America/Denver',
})

export const longDateOnlyFormatter = new Intl.DateTimeFormat('en-US', {
  dateStyle: 'long',
  timeZone: 'America/Denver',
})

export const FormatDate = ({ date, formatter: defaultFormatter }: { date: Date; formatter: Intl.DateTimeFormat }) => {
  const [clientFormatter, setClientFormatter] = useState<Intl.DateTimeFormat | null>(null)

  useEffect(() => {
    setClientFormatter(
      new Intl.DateTimeFormat('en-US', {
        ...(defaultFormatter.resolvedOptions() as Intl.DateTimeFormatOptions),
        timeZone: undefined,
      }),
    )
  }, [defaultFormatter])

  const formatter = clientFormatter || defaultFormatter

  return <>{formatter.format(date)}</>
}
